import { required, email, ValidationRule } from 'vuelidate/lib/validators';

export interface LoginConfig {
  data: {
    email: string | null;
    password: string | null;
  };
  html: {
    default: {
      header: {
        title: string;
        text: null;
      };
      button: {
        text: string;
        icon: null;
      };
      buttonSecondary: {
        text: string;
        icon: null;
      };
    };
    input: {
      model: string;
      type: string;
      placeholder: string;
      autocomplete?: string;
    }[];
  };
  validations: {
    email: {
      required: () => ValidationRule;
      email: () => ValidationRule;
    };
    password: {
      required: () => ValidationRule;
    };
  };
}

export default {
  data: {
    email: null,
    password: null,
  },
  html: {
    default: {
      header: {
        title: 'Prisijunkite',
        text: null,
      },
      button: {
        text: 'Prisijungti',
        icon: null,
      },
      buttonSecondary: {
        text: 'Prisijungti be slaptažodžio',
        icon: null,
      },
    },
    input: [
      {
        model: 'email',
        type: 'email',
        placeholder: 'El. paštas',
        readonly: true,
        autocomplete: 'email',
      },
      {
        model: 'password',
        type: 'password',
        placeholder: 'Slaptažodis',
        focus: true,
        autocomplete: 'current-password',
      },
    ],
  },
  validations: {
    email: {
      required,
      email,
    },
    password: {
      required,
    },
  },
};
